export class Address {

    zipcode: string;
    street: string;
    streetNumber: string;
    neighborhood: string;
    city: string;
    addressDetail: string;
    state: string;

    /**
    * Instanciar um
    * @param init - JSON que represente parcialmente as propriedades da classe
    */
    public constructor(init?: Partial<Address>) {
        Object.assign(this, init);
    }

    toFirebase(): object {
        return {
            zipcode: this.zipcode,
            street: this.street,
            streetNumber: this.streetNumber,
            neighborhood: this.neighborhood,
            city: this.city,
            state: this.state,
            addressDetail: this.addressDetail
        };
    }

}
